import { render, staticRenderFns } from "./clientTable.vue?vue&type=template&id=177bc1e3&"
import script from "./clientTable.vue?vue&type=script&lang=js&"
export * from "./clientTable.vue?vue&type=script&lang=js&"
import style0 from "./clientTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports